
import { defineComponent, PropType, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { GatewayPermissionT } from '@/core/types/gateway.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<GatewayPermissionT>,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update', 'delete'],
    setup(props, { emit }) {
        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const emitDelete = () => {
            emit('delete', props.item.id)
        }

        return { emitUpdate, emitDelete }
    },
})
